export default {
  detects: [],
  auto_detects: {}
}